import cv from '../cv.js';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { Heading, Text, Avatar} from 'dracula-ui'; 
import Book from './Book.js';
import { Container } from 'react-bootstrap';

function Header() {
  return(
    <>
      <Row>
        <Col md={{span: 2, offset: 1}}><Book /></Col>
        <Col md={{ span: 8, offset: 1 }}>
          <Container>
            <Row>
              <Col md={{span: 6, offset: 2}}>
                <Avatar
                  src={cv.basics.image}
                  title="David Granjon picture"
                  borderVariant="large"
                  color="white"
                />
              </Col>
            </Row>
            <Row>
              <Col>
                <Heading>Hi, I am {cv.basics.name}!</Heading>
                <Heading size="sm">{cv.basics.label}</Heading>
                <Text lineHeight="xl">{cv.basics.summary}</Text>
              </Col>
            </Row>
          </Container>
        </Col>
      </Row>
    </>
  );
}

export default Header;